import { fetcher } from 'services/helpers/responseHandler'

const getIsActiveByPath = path => fetcher.get('feature', { path })

const maintenanceApi = {
  getIsActiveByPath
}

export default maintenanceApi
